export default __webpack_public_path__ + "static/media/appstore-google.6c550c77.png";